import { render } from "./PageTemplate.vue?vue&type=template&id=7edac475&ts=true"
import script from "./PageTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageTemplate.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/PageTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7edac475"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7edac475', __exports__)) {
    api.reload('7edac475', __exports__)
  }
  
  module.hot.accept("./PageTemplate.vue?vue&type=template&id=7edac475&ts=true", () => {
    api.rerender('7edac475', render)
  })

}


export default __exports__